import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 md:py-32 bg-gradient-to-b from-[#1e3a5f] to-[#152d47] text-white relative overflow-hidden" data-id="element-66">
      {/* Subtle background effects */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-67"></div>
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#d4a574] opacity-5 rounded-full blur-3xl" data-id="element-68"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#f4e4d7] opacity-5 rounded-full blur-3xl" data-id="element-69"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center space-y-8" data-id="element-71">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 leading-relaxed text-[#f4e4d7]" data-id="element-72">
            Tu siguiente paso… es más importante de lo que crees.
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-73">
            <p data-id="element-74">
              Puedes seguir viviendo otros seis meses con esa sensación en el
              pecho…
            </p>

            <div className="space-y-3 text-gray-400 italic" data-id="element-75">
              <p data-id="element-76">😰 Estrés cada vez que abres la app del banco.</p>
              <p data-id="element-77">😨 Miedo de ver cuánto debes.</p>
              <p data-id="element-78">😔 Esa frase silenciosa: "El dinero se va solo…"</p>
            </div>

            <p className="pt-4" data-id="element-79">Pero algo dentro de ti ya lo sabe…</p>

            <p className="text-2xl md:text-3xl font-serif font-bold text-white leading-relaxed" data-id="element-80">
              No es el dinero el que se escapa.
              <br data-id="element-81" />
              Es el control que aún no has reclamado.
            </p>

            <div className="pt-6 space-y-4" data-id="element-82">
              <p data-id="element-83">
                Y en este momento… puedes volver a cerrar esta página como
                antes.
              </p>
              <p data-id="element-84">O puedes hacer algo radicalmente diferente:</p>
            </div>

            <div className="py-8 space-y-2 text-[#d4a574] font-semibold text-xl" data-id="element-85">
              <p data-id="element-86">30 días.</p>
              <p data-id="element-87">Una guía.</p>
              <p data-id="element-88">Un compromiso contigo.</p>
            </div>

            <div className="space-y-4 text-gray-300" data-id="element-89">
              <p data-id="element-90">No necesitas hacerlo perfecto.</p>
              <p data-id="element-91">Solo necesitas empezar.</p>
              <p className="text-xl font-semibold text-white" data-id="element-92">
                Solo necesitas decidir:{' '}
                <span className="text-[#d4a574]" data-id="element-93">
                  "Hoy cambio mi historia."
                </span>
              </p>
            </div>

            <p className="pt-6 text-gray-400 italic" data-id="element-94">
              Y mientras lees estas palabras, quizás ya sientes una parte de ti
              moviéndose hacia esa versión tuya…
            </p>

            <p className="text-xl text-white" data-id="element-95">
              Esa mujer que ya no le teme a sus números… que sabe exactamente
              qué entra, qué sale, y qué construir.
            </p>

            <p className="pt-8 text-2xl font-serif text-[#f4e4d7]" data-id="element-96">
              Todo empieza con una decisión.
            </p>
            <p className="text-3xl font-serif font-bold text-white" data-id="element-97">La tuya.</p>
          </div>

          <div className="pt-12" data-id="element-98">
            <motion.a href="#oferta" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-flex items-center justify-center gap-3 bg-[#d4a574] hover:bg-[#c29463] text-[#1e3a5f] font-bold text-lg md:text-xl px-10 py-5 rounded-xl shadow-2xl shadow-[#d4a574]/30 transition-all" data-id="element-99">
              Sí, quiero tomar el control de mi dinero desde hoy
              <ArrowRight className="w-6 h-6" data-id="element-100" />
            </motion.a>

            <p className="text-sm text-gray-500 mt-6" data-id="element-101">
              Acceso inmediato • Garantía de 30 días • Pago seguro
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}